import { useIntl } from 'react-intl'
import theme from 'theme_'

import { homeDeviceInformationMessages as messages } from '../../messages'
import DeviceInformationCard from '../../components/DeviceInformationCard'
import { DeviceStatusColorProps } from '../types'

function RedStatus({ statusString }: DeviceStatusColorProps) {
  const { formatMessage } = useIntl()

  return (
    <DeviceInformationCard
      title={formatMessage(messages.deviceConnectionStatusLabel)}
      value={statusString || formatMessage(messages.deviceStatusCardErrors)}
      color={theme.colors.error}
      bgColor={theme.colors.lightRed}
      order={1}
    />
  )
}

export default RedStatus
